import { useState, useEffect, useCallback } from "react";
import { apiCall } from "../../../../_services/apiCall";
import config from "../../../../config/config";

const useKpiTriggers = (financialYearId) => {
  const [triggers, setTriggers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTriggers = useCallback(async () => {
    if (!financialYearId) { setTriggers([]); return; }
    setLoading(true);
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}triggers/${financialYearId}`,
        {},
        {},
        "GET"
      );
      if (isSuccess) setTriggers(data.data || []);
      else setTriggers([]);
    } catch {
      setTriggers([]);
    } finally {
      setLoading(false);
    }
  }, [financialYearId]);

  useEffect(() => { fetchTriggers(); }, [fetchTriggers]);

  return { triggers, loading };
};

export default useKpiTriggers;
